module.exports = __webpack_public_path__ + "img/2193627793985415.424c20ae.jpg";